import { Trans, useTranslation } from 'react-i18next'

const LINK_CLASS =
  'text-primary underline underline-offset-2 hover:text-primary/80'

export function TosAgreeCopy() {
  const { t } = useTranslation('auth')

  return (
    <Trans
      t={t}
      i18nKey="complete.tos"
      components={{
        terms: (
          <a
            href="https://www.fairgen.ai/legal/dt-terms-of-use"
            target="_blank"
            rel="noopener noreferrer"
            className={LINK_CLASS}
          />
        ),
        privacy: (
          <a
            href="https://www.fairgen.ai/legal/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className={LINK_CLASS}
          />
        ),
      }}
    />
  )
}
